import React from 'react';

import styles from './Stepper.module.scss';
import { CLASSES } from '../../helper/functions';
import useStepperStore from '../../store/StepperStore';
import Icon from '../icon/Icon';
import Portal from '../portal/Portal';

interface StepperNavigationProps {
  onPrev?: () => void;
  onNext: () => void;
  isValid: boolean;
}

const StepperNavigation: React.FC<StepperNavigationProps> = ({
  onPrev = () => {},
  onNext = () => {},
  isValid = false,
}) => {
  const { currentItem, setStepper } = useStepperStore();

  //#region Handler
  const handlePrevBtn = () => {
    onPrev();
  };

  const handleNextBtn = () => {
    onNext();
  };
  //#endregion

  return (
    <Portal root="footer">
      <div className={styles.formNavContainer}>
        <div
          className={CLASSES(
            styles.prevBtn,
            currentItem && currentItem.id == 1 && styles.disable__
          )}
          onClick={handlePrevBtn}
        >
          <Icon src={'/icons/back.svg'} />
          Prev
        </div>
        <div
          className={CLASSES(styles.nextBtn, !isValid && styles.disable__)}
          onClick={handleNextBtn}
        >
          {currentItem.id == 10 ? (
            'Submit'
          ) : (
            <>
              Next <Icon src={'/icons/next.svg'} />
            </>
          )}
        </div>
      </div>
    </Portal>
  );
};

export default StepperNavigation;
